import { render, staticRenderFns } from "./LocusZoomAssociationsPanel.vue?vue&type=template&id=58c11d60&"
import script from "./LocusZoomAssociationsPanel.vue?vue&type=script&lang=js&"
export * from "./LocusZoomAssociationsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c11d60')) {
      api.createRecord('58c11d60', component.options)
    } else {
      api.reload('58c11d60', component.options)
    }
    module.hot.accept("./LocusZoomAssociationsPanel.vue?vue&type=template&id=58c11d60&", function () {
      api.rerender('58c11d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lz/panels/LocusZoomAssociationsPanel.vue"
export default component.exports